import { Flex, Grid, pxArrayToRem, useStyles } from '@archipro-design/aria';
import type { ReactNode } from 'react';
import * as S from './ManageFormRow.style';

interface FormRowProps {
    label: string;
    field: ReactNode;
    error?: string;
}
export const FormRow = ({ label, field, error }: FormRowProps) => {
    const { css } = useStyles();

    return (
        <Grid columns={pxArrayToRem([216, 348])}>
            <Flex column={true} className={css(S.LabelWrapper)}>
                {label}
            </Flex>
            <Flex column={true} className={css(S.RowWrapper)}>
                {field}
                {error && <div className={css(S.ErrorText)}>{error}</div>}
            </Flex>
        </Grid>
    );
};
